import parser from 'ua-parser-js'
import { includes, cond, max } from 'lodash-es'

import withLivingSinyi from 'utils/withLivingSinyi'
import VenderList, { NUMBER_PER_PAGE } from 'components/pages/Vender/VenderList'
import MetaTags from 'components/pages/Vender/VenderList/MetaTags'
import NoindexRemoval from 'components/common/NoindexRemoval'
import {
  getVenders,
  getVenderCount,
  getServiceClassificationById,
} from 'utils/api'
import { safeDecodeURIComponent } from 'utils/helpers'

const VenderListPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <VenderList {...props} />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        serviceCounty={props.fallbackData.serviceCounty}
        district={props.fallbackData.district}
        serviceClassificationFilter={
          props.fallbackData.serviceClassificationFilter
        }
        searchText={props.fallbackData.searchText}
        page={props.fallbackData.page}
      />
    </>
  )
}

export const getServerSidePropsFunction = async (context) => {
  const ua = parser(context.req.headers['user-agent'])

  const isMobile = includes(['mobile', 'tablet'], ua.device.type)

  const page = isMobile ? 1 : parseInt(context.query?.page) || 1

  // serviceItem is one specific serviceClassificationId
  const serviceItem = context.query?.serviceItem || ''
  const serviceCounty = decodeURIComponent(context.query?.serviceCounty || '')
  const district = decodeURIComponent(context.query?.district || '')
  const searchText = safeDecodeURIComponent(context.query?.keyword)

  const limit = NUMBER_PER_PAGE
  const skip = isMobile ? 0 : max([page - 1, 0]) * NUMBER_PER_PAGE
  const vendersQuery = cond([
    [({ search }) => !!search, ({ search }) => ({ search, limit, skip })],
    [() => true, () => ({ limit, skip })],
  ])({ search: searchText })
  const vendersPromise = getVenders(vendersQuery)

  const { limit: venderLimit, ...venderCountQuery } = vendersQuery
  const venderCountPromise =
    !isMobile && searchText
      ? getVenderCount(venderCountQuery)
      : Promise.resolve([null])

  const [vendersResult, venderCountResult] = await Promise.all([
    vendersPromise,
    venderCountPromise,
  ])
  const [venders, vendersError] = vendersResult
  const [venderCount, vendersCountError] = venderCountResult

  const [serviceClassification] = serviceItem
    ? await getServiceClassificationById(serviceItem)
    : []

  return {
    props: {
      isMobile,
      fallbackData: {
        page,
        searchText,
        serviceItem,
        serviceCounty,
        district,

        // fetched data
        venders: venders !== undefined ? venders : null,
        venderCount,
        serviceClassificationFilter: serviceClassification || null,
      },
      resolvedUrl: context.resolvedUrl,
    },
  }
}

export const getServerSideProps = getServerSidePropsFunction

export default withLivingSinyi(VenderListPage)
